<template>
  <div>
    <UHeader class="py-2">
      <template #logo>
        <div class="h-14 flex items-center gap-2">
          <img src="~/assets/FaviconPNG.png" alt="Calculator Logo" class="h-full">
          <span class="text-lg font-semibold">Unit Converter</span>
        </div>
      </template>

      <template #right>
        <div class="h-14 flex items-center gap-0">
          <UButton
                   icon="i-heroicons-home"
                   variant="link"
                   class="text-lg font-semibold hidden sm:block">
            Home
          </UButton>
          <UColorModeToggle  />
        </div>
      </template>
    </UHeader>
    <UMain>
      <NuxtPage />
    </UMain>

    <UFooter>
      <template #center>
        Copyright © {{ new Date().getFullYear() }}
      </template>
    </UFooter>
  </div>
</template>
